module.exports = __webpack_public_path__ + "img/34690670000186.958ec323.png";